import{e as t,m as o}from"./chunk-HBP5N4FR.js";function m(r){return r[Math.floor(Math.random()*r.length)]}var n=t(()=>{o()});export{m as a,n as b};
//# sourceMappingURL=chunk-6ZGFYJ6T.js.map
